import { atom } from 'jotai'

export const showPreviewAtom = atom<boolean>(true)

export type PreviewMode = 'PDF' | 'EMAIL' | 'CUSTOMER_PORTAL'

export const previewConfigAtom = atom<{
  previewMode: PreviewMode
  transitionDirection: 'LEFT_TO_RIGHT' | 'RIGHT_TO_LEFT'
}>({ previewMode: 'PDF', transitionDirection: 'LEFT_TO_RIGHT' })

export const previewContainerRefAtom = atom<HTMLDivElement | null>(null)
